<template>
    <div>
        
        <transition name="fade-fast" mode="out-in">
            
            <busy-spinner
                v-if="loadingList"
                key="loadingListTrue"
                inner-class="my-5"
                text="Loading..."
            ></busy-spinner>

            <div
                v-else
                key="loadingListFalse"
            >
                <div
                    v-for="(todos, group_key) in todoListGroups"
                    :key="group_key"
                    class="mt-5"
                >
                    <h5 class="rounded bg-gray-100 p-2" style="">
                        <b-icon :icon="todos[0].rctd.categoryIcon" variant="primary" class="mr-2"></b-icon>
                        {{ todos[0].rctd.categoryName }}s
                    </h5>

                    <div 
                        v-for="todo in todos"
                        :key="todo.id"
                        class="rounded-lg border my-3 py-2 px-3"
                        :class="visibleTodoObject[todo.id] ? 'shadow-sm' : 'border-white'"
                    >
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="w-30 d-flex gap-2 align-items-center">
                                <div class="font-weight-bold text-wrap">{{ todo.rctd.title }}</div>
                                <div 
                                    v-if="todo.rctd && todo.rctd.isHidden"
                                    :id="'todo-hidden-' + todo.rctd.id"
                                    v-b-tooltip.hover 
                                    title="Currently hidden from suppliers"
                                    class="font-size-80 d-flex align-items-center text-warning-darker px-1 bg-warning-100 border border-warning rounded-pill"
                                >
                                    <b-icon icon="eye-slash-fill"></b-icon>
                                </div>
                            </div>
                            <div class="w-25 text-center">
                                <b-badge
                                    :variant="todo.replyStatusBadgeClass"
                                    class="mx-2 text-nowrap text-uppercase"
                                >
                                    {{ todo.replyStatusInternalHeading }}
                                </b-badge>
                            </div>
                            <div class="w-25 text-center">{{ todo.lastSubmittedReply ? todo.lastSubmittedReply.submittedOn : '-' }}</div>
                            <div class="w-20 text-right">
                                <b-link 
                                    v-if="todo.is_submitted"
                                    class="font-size-80 text-uppercase text-decoration-none font-weight-700"
                                    @click="toggleTodoReply(todo)"
                                >  <!-- v-b-toggle="'todo-collapse-' + todo.id" -->
                                    {{ visibleTodoObject[todo.id] ? 'Hide Details' : 'View Details' }}
                                    <b-icon :icon="visibleTodoObject[todo.id] ? 'dash-circle' : 'plus-circle'" class="ml-2"></b-icon>
                                </b-link>
                            </div>
                        </div>

                        <b-collapse :id="'todo-collapse-' + todo.id" :visible="visibleTodoObject[todo.id]">
                            <div class="pt-4">
                                <doc-request-reply-viewer 
                                    v-if="(todo.category === 'docrequest' && loadedTodoObject[todo.id]) && !!todo.lastSubmittedReplyId"
                                    :reply-id="todo.lastSubmittedReplyId"
                                    class="mb-2"
                                ></doc-request-reply-viewer>
                                <formium-reply-viewer 
                                    v-else-if="(todo.category === 'formium_form' && loadedTodoObject[todo.id]) && !!todo.lastSubmittedReplyId"
                                    :reply-id="todo.lastSubmittedReplyId"
                                ></formium-reply-viewer>
                                <quote-sheet-reply-data
                                    v-else-if="(todo.category === 'quotesheet' && loadedTodoObject[todo.id]) && !!todo.lastSubmittedReplyId"
                                    :reply-id="todo.lastSubmittedReplyId"
                                ></quote-sheet-reply-data>
                                <smart-form-reply-viewer
                                    v-else-if="(todo.category === 'smartform' && loadedTodoObject[todo.id]) && !!todo.lastSubmittedReplyId"
                                    :reply-id="todo.lastSubmittedReplyId"
                                ></smart-form-reply-viewer>
                            </div>
                        </b-collapse>

                    </div>

                    <!-- <b-table
                        class="todo-reply-viewer-table"
                        :items="todos"
                        :fields="todoTableFields"
                        primary-key="id"
                        thead-class="d-none"
                        :tbody-transition-props="transitionProps"
                    >
                        <template #cell(status)="data">
                            <b-badge
                                :variant="data.item.replyStatusBadgeClass"
                                class="mx-2 text-nowrap text-uppercase"
                            >
                                {{ data.value }}
                            </b-badge>
                        </template>
                        <template #cell(actions)="data">
                            <b-link 
                                v-if="data.item.is_submitted"
                                class="font-size-80 text-uppercase text-decoration-none font-weight-700"
                                @click="data.toggleDetails"
                            >
                                {{ data.detailsShowing ? 'Close' : 'View' }}
                                <b-icon :icon="data.detailsShowing ? 'dash-circle' : 'plus-circle'" class="ml-2"></b-icon>
                            </b-link>
                        </template>
                        <template #row-details="data">
                            <div class="mb-3">
                                <doc-request-reply-viewer 
                                    v-if="(data.item.category === 'docrequest') && !!data.item.lastSubmittedReplyId"
                                    :reply-id="data.item.lastSubmittedReplyId"
                                ></doc-request-reply-viewer>
                                <formium-reply-viewer 
                                    v-else-if="(data.item.category === 'formium_form') && !!data.item.lastSubmittedReplyId"
                                    :reply-id="data.item.lastSubmittedReplyId"
                                ></formium-reply-viewer>
                                <quote-sheet-reply-data
                                    v-else-if="(data.item.category === 'quotesheet') && !!data.item.lastSubmittedReplyId"
                                    :reply-id="data.item.lastSubmittedReplyId"
                                ></quote-sheet-reply-data>
                            </div>
                        </template>
                    </b-table> -->

                </div>
            </div>
        </transition>

    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';
import { RfxCompanyToDoReplyStatus } from './rfx_company_todo_classes';
import groupBy from 'lodash/groupBy';
import { DateTime } from 'luxon';
import DocRequestReplyViewer from '../docrequests/DocRequestReplyViewer.vue';
import FormiumReplyViewer from '../formium/FormiumReplyViewer.vue';
import QuoteSheetReplyData from '../quotesheets/QuoteSheetReplyData.vue';
import SmartFormReplyViewer from '../smartforms/SmartFormReplyViewer.vue';

export default {
    name: 'RfxResponseTodoReplyViewer',
    components: {
        DocRequestReplyViewer,
        FormiumReplyViewer,
        QuoteSheetReplyData,
        SmartFormReplyViewer,
    },
    mixins: [
        errorHandling,
    ],
    props: {
        responseId: {
            type: [String, Number],
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loadingList: false, 
            todoList: [],  
            todoListGroups: {},  // maps todoList by category_key
            transitionProps: {
                name: 'row-fade',
            },
            visibleTodoObject: null,  // will be object with keys of todo.id, values of boolean, where boolean is v-model for which collapses are EXPANDED / VISIBLE
            loadedTodoObject: null,  // will be object with keys of todo.id, values of boolean, where boolean is whether or not this todo has been loaded yet - used in v-if to conditionally load the actual content
            // we'll set key/value to true the first time collapse for that todo is shown -- then never set it false again... just leave it loaded -- if vendor changes their response, buyer will have to do a full reload of the component to see latest (should be OK)
            todoTableFields: [
                {
                    key: 'title',
                    formatter: (value, key, item) => {
                        return item.rctd.title;
                    },
                    tdClass: ['w-35', 'cells-align-middle', 'font-weight-bold'],
                },
                {
                    key: 'status',
                    formatter: (value, key, item) => {
                        return item.replyStatusInternalHeading;
                    },
                    tdClass: ['w-20', 'cells-align-middle', 'text-center'],
                },
                {
                    key: 'submitted_on',
                    formatter: (value, key, item) => {
                        let submittedOn = item.lastSubmittedReply?.submitted_on;
                        return submittedOn ? submittedOn.toLocaleString(DateTime.DATETIME_MED) : '-';
                    },
                    tdClass: ['w-25', 'font-size-70', 'text-muted', 'cells-align-middle', 'text-center'],
                },
                {
                    key: 'actions',
                    tdClass: ['w-20', 'text-right'],
                }
            ],
            multipleQuoteSheetReplies: null,  // JUST FOR TESTING
        }
    },
    computed: {

    },
    mounted: function() {
        this.getTodos();
    },
    methods: {
        // use apiErrorHandler from mixin
        makeToDoInstances: function(RctdReplyStatusList) {
            // build list of RfxCompanyToDoReplyStatus instances, return it
            if (!RctdReplyStatusList.length) return [];
            let todos = RctdReplyStatusList.map(todo => new RfxCompanyToDoReplyStatus(todo));
            // add _showDetails property to all items, used to toggle detail area in b-table
            todos.forEach(todo => {
                todo._showDetails = false;
            });
            return todos;
        },
        getTodos: function() {
            this.loadingList = true;
            return suppliosApi.rfxResponse.listRfxCompanyToDosInternal(this.responseId)
                .then(response => {
                    this.todoList = this.makeToDoInstances(response.data);
                    this.loadedTodoObject = Object.fromEntries(this.todoList.map(td => [td.id, false]));  // make a new object from key/value pairs, where key is todo.id, value is boolean for whether this todo has been loaded yet
                    this.visibleTodoObject = {...this.loadedTodoObject};  // make a shallow copy to use for v-model for VISIBILITY of collapse (not loading)
                    console.log(this.loadedTodoObject);
                    this.todoListGroups = groupBy(this.todoList, 'rctd.category_key');
                    return true;
                })
                .catch(error => {
                    this.apiErrorHandler(error);
                    return false;
                })
                .then(success => {
                    this.loadingList = false;
                    return success;
                });
        },
        toggleTodoReply: function(todoReplyObj) {
            // toggle the visibility (this.visibleTodoObject) but only set loadedTodoObject one way (true) -- so we don't have to keep loading again every time user toggles visibility
            console.log(todoReplyObj);
            console.log(todoReplyObj.id);
            this.loadedTodoObject[todoReplyObj.id] = true;
            console.log(this.loadedTodoObject);
            this.visibleTodoObject[todoReplyObj.id] = !this.visibleTodoObject[todoReplyObj.id];
        },
    }
}
</script>

<style lang="scss">

.todo-reply-viewer-table > tbody > tr {  // using immediate child elements because you have nested tables
    //border-width: 1px 1px 0 1px;
    //border-style: solid;
    //border-color: transparent; // setting this so it doesn't transition from its default color
    transition: background-color 0.5s, border-color 0.5s;

    /* > td {
        transition: border-color 0.5s;
    } */

    /* &.b-table-details,
    &.b-table-details > td,
    &[aria-details],
    &[aria-details] > td {
        //background-color: $gray-50;
        ///border-color: $primary;
        //border-style: solid;
        //border-color: $primary-300;
    } */
    &[aria-details] {  // the is the normal row, when detail is open
        background-color: $gray-100;
        //border-width: 0 0 0 1px;
        ///border-width: 1px 1px 0 1px;
        //border-top-left-radius: 0.5rem;
        //border-top-right-radius: 0.5rem;
    }
    /* &.b-table-details {  // this is the extra detail row
        //border-width: 0 0 0 1px;
        ///border-width: 0 1px 1px 1px;
        //border-bottom-left-radius: 0.5rem;
        //border-bottom-right-radius: 0.5rem;
    } */
}

// transition things
.todo-reply-viewer-table {
    .b-table-details {
        &.row-fade-enter-active {
            transition: opacity 1s, border-color 1s;
        }
        &.row-fade-leave-active {
            transition: opacity 0.5s, border-color 0.5s;
        }
        &.row-fade-enter,
        &.row-fade-leave-to {
            opacity: 0;
            border-color: transparent;
        }
    }
}


</style>